import React from 'react';
import Typography from '@material-ui/core/Typography';
import {
  AuditorCompanyType,
  AuditorStoreState,
} from '../../../auditor/auditor-types';
import { SummaryLabelledInfo } from '../labelled-info';
import { Person } from '../../../../../../global/entities/Person';
import { AuditorOptionLabel } from '../../../auditor/auditor-utils';

interface SummaryAuditorProps {
  auditor: Omit<AuditorStoreState, 'auditorPerson'> & {
    auditorPerson: Partial<AuditorStoreState['auditorPerson']>;
  };
}

export const SummaryAuditor = ({ auditor }: SummaryAuditorProps) => {
  const { auditorPerson, auditorOption, auditorFirm } = auditor;

  const isPerson = (auditor?: typeof auditorPerson): auditor is Person => {
    // noinspection RedundantIfStatementJS
    if (!auditor || auditorOption === 'no') {
      return false;
    }
    return true;
  };

  const isFirm = (
    auditor: typeof auditorFirm,
    // @ts-ignore
  ): auditor is AuditorCompanyType => {
    // noinspection RedundantIfStatementJS
    if (!auditor || auditorOption === 'no' || auditorOption === 'person') {
      return false;
    }
    return true;
  };

  const renderPerson = () => {
    if (!isPerson(auditorPerson)) return null;

    const {
      firstName,
      lastName,
      socialSecurityNumber,
      address,
      postalCode,
      city,
    } = auditorPerson;

    return (
      <>
        <Typography variant="h6" gutterBottom>
          Huvudansvarig Revisor:
        </Typography>
        <SummaryLabelledInfo label="Samtliga förnamn">
          {firstName}
        </SummaryLabelledInfo>
        <SummaryLabelledInfo label="Efternamn">{lastName}</SummaryLabelledInfo>
        <SummaryLabelledInfo label="Personnummer">
          {socialSecurityNumber}
        </SummaryLabelledInfo>
        <SummaryLabelledInfo label="Utdelningsadress">
          {address}
        </SummaryLabelledInfo>
        <SummaryLabelledInfo label="Postnummer">
          {postalCode}
        </SummaryLabelledInfo>
        <SummaryLabelledInfo label="Ort">{city}</SummaryLabelledInfo>
      </>
    );
  };

  const renderFirm = () => {
    if (!isFirm(auditorFirm)) return null;

    const {
      organizationAddress,
      organizationCity,
      organizationPostalCode,
      organizationName,
      organizationNumber,
    } = auditorFirm;

    return (
      <>
        <Typography gutterBottom variant="h6">
          Revisionsbolag:
        </Typography>
        <SummaryLabelledInfo label="Revisionsbolagets namn">
          {organizationName}
        </SummaryLabelledInfo>
        <SummaryLabelledInfo label="Organisationsnummer">
          {organizationNumber}
        </SummaryLabelledInfo>
        <SummaryLabelledInfo label="Utdelningsadress">
          {organizationAddress}
        </SummaryLabelledInfo>
        <SummaryLabelledInfo label="Postnummer">
          {organizationPostalCode}
        </SummaryLabelledInfo>
        <SummaryLabelledInfo label="Ort">
          {organizationCity}
        </SummaryLabelledInfo>
      </>
    );
  };

  return (
    <React.Fragment>
      <SummaryLabelledInfo label="Har bolaget revisor?">
        {AuditorOptionLabel[auditorOption]}
      </SummaryLabelledInfo>

      {renderPerson()}
      {renderFirm()}
    </React.Fragment>
  );
};
